import React from 'react';

/**
 * FilterControls Component
 * 
 * Filter and sort controls for attachments list:
 * - Type filter buttons (All, Image, Document, etc.)
 * - Sort dropdown (Date, Size, Type)
 */
const FilterControls = ({
  filterType,
  setFilterType,
  sortBy,
  setSortBy,
  uniqueTypes,
}) => {
  return (
    <div className="attachments-modal__controls">
      <div className="attachments-modal__filters">
        <button 
          className={`attachments-modal__filter-btn ${filterType === 'all' ? 'attachments-modal__filter-btn--active' : ''}`}
          onClick={() => setFilterType('all')}
        >
          All
        </button>
        {uniqueTypes.map(type => (
          <button 
            key={type}
            className={`attachments-modal__filter-btn ${filterType === type ? 'attachments-modal__filter-btn--active' : ''}`}
            onClick={() => setFilterType(type)}
          >
            {type.charAt(0).toUpperCase() + type.slice(1)}
          </button>
        ))}
      </div>
      
      <div className="attachments-modal__sort">
        <span className="attachments-modal__sort-label">Sort by</span>
        <select 
          value={sortBy} 
          onChange={(e) => setSortBy(e.target.value)}
          className="attachments-modal__sort-select"
        >
          <option value="date">Date</option>
          <option value="size">Size</option>
          <option value="type">Type</option>
        </select>
      </div>
    </div>
  );
};

export default FilterControls;
